import { Breadcrumb, Button, Card, Col, Drawer, Form, Input, Modal, Row, Select, Space, Upload, UploadFile, UploadProps } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { useEffect, useState, useSyncExternalStore } from "react";
import styles from 'src/globals/Layout/Admin/AdminHeader.module.scss';
import { GetActivityById, deleteActivityDataById, deleteRepositories, getAllActivityByEstablishment, getPDFRepositories, getRepositories, postImportActivityDataExcel, postRepositories, postResgistActivity, putUpdateActivity } from "src/store/activity/thunks";
import { CloseCircleOutlined, UploadOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, ArrowLeftOutlined, FileExcelOutlined } from '@ant-design/icons';
import { GetEstablishmentGeiInventoryById } from "src/store/establishment/thunks";
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import { ActivitiesSourceResponse, EmissionActivity } from "src/store/activity/types";
import { getEstablishmentById } from "src/store/establishment/thunks";
import { validateDecimal4 } from "src/globals/Inputs/validateInput";
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { getAllEmissionsTable, getEmissionsOrganization } from "src/store/emissions/thunks";
import { EmissionsSource } from "src/store/emissions/types";
import { getTransformationFactorsUnitByEmissionorganizationId, getTransformationFactorsUnitByEmissionId, getTransformationFactorsUnitByEmissionSourceId } from "src/store/transformationfactors/thunks";
import * as XLSX from 'xlsx';
import { openNotification } from "src/globals/Components/Notification/Notificaction";
import { formatNumberString } from "src/globals/Funciones/funciones";
import { getGeiInventoryById } from "src/store/geiInventory/thunks";
import { listMonths } from "src/globals/Parameters/listParameters";
import { getEmissionsById } from "src/store/emissions/thunks";
interface TableProps {

    getAllActivityByEstablishment?: any;
    getAllEmissionsTable?: any;
    GetActivityById?: any;
    postResgistActivity?: any;
    putUpdateActivity?: any;
    getEmissionsOrganization?: any;
    getTransformationFactorsUnitByEmissionorganizationId?: any;
    getGeiInventoryById?: any;
    getEstablishmentById?: any;
    deleteActivityDataById?: any;
    getTransformationFactorsUnitByEmissionSourceId?:any;

    getRepositories?: any;
    postRepositories?: any;
    deleteRepositories?: any;
    getPDFRepositories?: any;
    GetEstablishmentGeiInventoryById?: any;
    getTransformationFactorsUnitByEmissionId?: any;
    getEmissionsById?: any;
    postImportActivityDataExcel?:any;
}

interface DataType {
    key: String;
    emission_source_name: string;
    establishment_name: string;
    id: string;
    emissionSourcesOrganizationId: string;
    establishmentId: string;
    baseUnit: string;
    eneIncome: number;
    ene: number;
    febIncome: number;
    feb: number;
    marIncome: number;
    mar: number;
    abrIncome: number;
    abr: number;
    mayIncome: number;
    may: number;
    junIncome: number;
    jun: number;
    julIncome: number;
    jul: number;
    agoIncome: number;
    ago: number;
    sepIncome: number;
    sep: number;
    octIncome: number;
    oct: number;
    novIncome: number;
    nov: number;
    dicIncome: number;
    dic: number;
    annual: number;
    unit: string;
    observations: string;
    createdAt: string;
    updatedAt: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';


const TActivity: React.FC<TableProps> = (props: TableProps) => {
    const [fileList, setFileList] = useState<File[]>([]);
    const [uploading, setUploading] = useState(false);

    const handleChange = (info: { fileList: UploadFile<any>[] }) => {
        // Mapeamos sobre la lista de archivos y extraemos el archivo de cada objeto UploadFile<any>
        const files: File[] = info.fileList.map(file => file.originFileObj as File);
        setFileList(files);
    };

    const propsRepo: UploadProps = {
        beforeUpload: (file) => {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                openNotification('Advertencia', `${file.name} no es un archivo .pdf`);
            }
            return isPDF ? true : Upload.LIST_IGNORE;
        },
        onChange: handleChange,
    };

    const propsRepoExcel: UploadProps = {
        beforeUpload: (file) => {
            const isExcel =
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'application/vnd.ms-excel';
            if (!isExcel) {
                openNotification('Advertencia', `${file.name} no es un archivo de Excel (.xlsx o .xls)`);
            }
            return isExcel ? true : Upload.LIST_IGNORE;
        },
        onChange: handleChange,
    };

    interface RouteParams {
        idEstablishmentGei: string,
        idGei: string;
    }
    const params = useParams<RouteParams>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idEmissions, setIdEmissions] = useState('');
    const [idActivity, setActivity] = useState('');
    const history = useHistory();
    const [dataTableEmissions, setDataTableEmissions] = useState([]);
    const [formValidate] = Form.useForm();
    const [formRepository] = Form.useForm();
    const [formImportExcel] = Form.useForm();
    const [establishment, setEstablishment] = useState([]);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [selectDataTableEmissions, setSelectDataTableEmissions] = useState<EmissionsSource[]>([]);
    const [searchValue, setSearchValue] = useState<EmissionsSource>();
    const [dataBaseUnit, setDataBaseUnit] = useState([]);
    const [dataGeiAge, setDataGeiAge] = useState('N/A');
    const [dataGeiUser, setDataGeiUser] = useState('N/A');

    const [idOrganization, setOrganization] = useState("");
    const [dataEstaYear, setDataEstaYear] = useState('N/A');
    const [dataEstaName, setDataEstaName] = useState('N/A');

    const [isModalEmision, setIsModalEmision] = useState(false);
    const [isImportExcel, setIsImportExcel] = useState(false);
    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);

    const { Option } = Select;
    //LLamar al EndPoint tanto en el Interface como en el Map, 
    const init = async () => {
        // const responseDataEmissions = await props.getAllEmissionsTable();
        //setDataTable(responseDataEmissions);
        
        const responseDataEstablishment = await props.getAllActivityByEstablishment(params.idEstablishmentGei);
        setDataTable(responseDataEstablishment);
        //setEstablishment(responseDataEstablishment);
        const responseDataGei = await props.getGeiInventoryById(params.idGei);
        setDataGeiAge(responseDataGei.year)
        setDataGeiUser(responseDataGei.personCharge)
        const responseDataEstablishmentGei = await props.GetEstablishmentGeiInventoryById(params.idEstablishmentGei);
        setDataEstaYear(responseDataEstablishmentGei.msIdentityEstablishmentCode)
        setDataEstaName(responseDataEstablishmentGei.msIdentityEstablishmentName)
        setOrganization(responseDataGei.msIdentity_organization_id)

    }
    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState<DataType[]>([]);

    const columns: ColumnsType<DataType> = [
        {
            title: 'Fuente de Emisión',
            dataIndex: 'emission_source_name',
            key: 'emission_source_name',
            fixed: 'left',
            width: 150,
        },
        {
            title: 'Fuente',
            dataIndex: 'flow',
            key: 'flow',
            width: 150,
        },
        {
            title: 'Unidad base',
            dataIndex: 'baseUnit',
            key: 'baseUnit',
            width: 150,
        },
        {
            title: 'Ene1',
            dataIndex: 'eneIncome',
            key: 'eneIncome',
            width: 100,
        },

        {
            title: 'Ene',
            dataIndex: 'ene',
            key: 'ene',
            width: 100,
        },
        {
            title: 'Feb1',
            dataIndex: 'febIncome',
            key: 'febIncome',
            width: 100,
        },
        {
            title: 'Feb',
            dataIndex: 'feb',
            key: 'feb',
            width: 100,
        },
        {
            title: 'Mar1',
            dataIndex: 'marIncome',
            key: 'marIncome',
            width: 100,
        },
        {
            title: 'Mar',
            dataIndex: 'mar',
            key: 'mar',
            width: 100,
        },
        {
            title: 'Abr1',
            dataIndex: 'abrIncome',
            key: 'abrIncome',
            width: 100,
        },
        {
            title: 'Abr',
            dataIndex: 'abr',
            key: 'abr',
            width: 100,
        },
        {
            title: 'May',
            dataIndex: 'mayIncome',
            key: 'mayIncome',
            width: 100,
        },
        {
            title: 'May',
            dataIndex: 'may',
            key: 'may',
            width: 100,
        },
        {
            title: 'Jun1',
            dataIndex: 'junIncome',
            key: 'junIncome',
            width: 100,
        },
        {
            title: 'Jun',
            dataIndex: 'jun',
            key: 'jun',
            width: 100,
        },
        {
            title: 'Jul1',
            dataIndex: 'julIncome',
            key: 'julIncome',
            width: 100,
        },
        {
            title: 'Jul',
            dataIndex: 'jul',
            key: 'jul',
            width: 100,
        },
        {
            title: 'Ago1',
            dataIndex: 'agoIncome',
            key: 'agoIncome',
            width: 100,
        },
        {
            title: 'Ago',
            dataIndex: 'ago',
            key: 'ago',
            width: 100,
        },
        {
            title: 'Sep1',
            dataIndex: 'sepIncome',
            key: 'sepIncome',
            width: 100,
        },
        {
            title: 'Sep',
            dataIndex: 'sep',
            key: 'sep',
            width: 100,
        },
        {
            title: 'Oct1',
            dataIndex: 'octIncome',
            key: 'octIncome',
            width: 100,
        },
        {
            title: 'Oct',
            dataIndex: 'oct',
            key: 'oct',
            width: 100,
        },
        {
            title: 'Nov1',
            dataIndex: 'novIncome',
            key: 'novIncome',
            width: 100,
        },
        {
            title: 'Nov',
            dataIndex: 'nov',
            key: 'nov',
            width: 100,
        },
        {
            title: 'Dic1',
            dataIndex: 'dicIncome',
            key: 'dicIncome',
            width: 100,
        },
        {
            title: 'Dic',
            dataIndex: 'dic',
            key: 'dic',
            width: 100,
        },
        {
            title: 'Anual',
            dataIndex: 'annual',
            key: 'annual',
            width: 100,
        },
        {
            title: 'Unidad',
            dataIndex: 'unit',
            key: 'unit',
            width: 100,
        },
        {
            title: 'Observaciones',
            dataIndex: 'observations',
            key: 'observations',
            width: 150,
        },
        {
            title: 'Creado en',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 100,
        },
        {
            title: 'Actualizado en',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: 150,
        },
        {
            title: 'Acción',
            key: 'operation',
            fixed: 'right',
            width: 250,

            render: (record: DataType) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => showEmissionModalUpdate(record.id)}
                    >
                        Archivos

                    </Button>
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => handleTypeOpenModelUpdate(record.id)}
                        icon={<EditOutlined />}
                    />
                    <Button
                        type="text"
                        className={style["eliminate-button"]}
                        onClick={() => handleTypeDeleteButton(record.id)}
                        icon={<CloseCircleOutlined />}
                    />
                </Space>
            ,
        },

    ];
    interface DataTypeRepository {
        key: string;
        name: string;
        type: string;
        month: string;
        start_date: string;
    }

    const columnsEmissions: ColumnsType<DataTypeRepository> = [
        {

            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Mes',
            width: 20,
            dataIndex: 'month',
            key: 'month',
        },
        {
            title: 'Acción',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: DataTypeRepository) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => handleViewRepository(record.name)}
                    // icon={<CloseCircleOutlined />}
                    >
                        Vizualizar

                    </Button>
                    <Button
                        type="text"
                        className={style["eliminate-button"]}
                        onClick={() => handleTypeDeleteButtonRepo(record.type)}
                        icon={<CloseCircleOutlined />}
                    />

                </Space>,
        },


    ];
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };



    const getEmissionByName = (name: string): EmissionsSource | undefined => {
        // Tomar solo la primera parte antes del primer guion
        const searchNamePart = name.split('-')[0].toLowerCase();

        return selectDataTableEmissions.find(emission => {
            // Comparar solo la primera parte del nombre antes del primer guion
            const emissionNamePart = emission.name.split('-')[0].toLowerCase();
            return emissionNamePart === searchNamePart;
        });
    };


    const handleTypeOpenModel = async () => {
        
        const responseDataOrganizationTable = await props.getEmissionsOrganization(idOrganization);
        setSelectDataTableEmissions(responseDataOrganizationTable);
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        
        const responseDataOrganizationTable = await props.getEmissionsOrganization(idOrganization);
        setSelectDataTableEmissions(responseDataOrganizationTable);
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: ActivitiesSourceResponse = await props.GetActivityById(value);
        setActivity(responseData.id);
        setIdEmissions(responseData.emission_source_id);
        const responseDataBaseUnit = await props.getTransformationFactorsUnitByEmissionId(idOrganization, responseData.emission_source_id);
        setDataBaseUnit(responseDataBaseUnit);
        const emission = responseDataOrganizationTable.find(
            (item: any) => item.id === responseData.emission_source_id
        );
        formValidate.setFieldsValue({
            emissions: emission.name + '-' + emission.flow,
            establishmentGeiInventoryId: responseData.emission_source_id,
            base: responseData.baseUnit,
            ene: formatNumberString(responseData.eneIncome, 7),
            feb: formatNumberString(responseData.febIncome, 7),
            mar: formatNumberString(responseData.marIncome, 7),
            abr: formatNumberString(responseData.abrIncome, 7),
            may: formatNumberString(responseData.mayIncome, 7),
            jun: formatNumberString(responseData.junIncome, 7),
            jul: formatNumberString(responseData.julIncome, 7),
            ago: formatNumberString(responseData.agoIncome, 7),
            sep: formatNumberString(responseData.sepIncome, 7),
            oct: formatNumberString(responseData.octIncome, 7),
            nov: formatNumberString(responseData.novIncome, 7),
            dic: formatNumberString(responseData.dicIncome, 7),
            annual: formatNumberString(responseData.annual, 7),
            unit: responseData.unit,
            observations: responseData.observations
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {       

        if (!typeModal) {

            const nameEmission: EmissionsSource | undefined = getEmissionByName(values.emissions)

            const Activities = {
                id: idActivity,
                emissionSourcesOrganizationId: nameEmission == undefined ? values.emissions : nameEmission.id,
                establishmentGeiInventoryId: params.idEstablishmentGei,
                baseUnit: values.base,
                eneIncome: values.ene,
                ene: values.ene,
                febIncome: values.feb == undefined ? null : values.feb,
                feb: values.feb == undefined ? null : values.feb,
                marIncome: values.mar == undefined ? null : values.mar,
                mar: values.mar == undefined ? null : values.mar,
                abrIncome: values.abr == undefined ? null : values.abr,
                abr: values.abr == undefined ? null : values.abr,
                mayIncome: values.may == undefined ? null : values.may,
                may: values.may == undefined ? null : values.may,
                junIncome: values.jun == undefined ? null : values.jun,
                jun: values.jun == undefined ? null : values.jun,
                julIncome: values.jul == undefined ? null : values.jul,
                jul: values.jul == undefined ? null : values.jul,
                agoIncome: values.ago == undefined ? null : values.ago,
                ago: values.ago == undefined ? null : values.ago,
                sepIncome: values.sep == undefined ? null : values.sep,
                sep: values.sep == undefined ? null : values.sep,
                octIncome: values.oct == undefined ? null : values.oct,
                oct: values.oct == undefined ? null : values.oct,
                novIncome: values.nov == undefined ? null : values.nov,
                nov: values.nov == undefined ? null : values.nov,
                dicIncome: values.dic == undefined ? null : values.dic,
                dic: values.dic == undefined ? null : values.dic,
                annual: null,
                unit: "",
                observations: values.observations == undefined ? "" : values.observations
            };
            await props.putUpdateActivity(Activities);
        } else {
            const nameEmission: EmissionsSource | undefined = getEmissionByName(values.emissions)
            const Activities = {
                emissionSourcesOrganizationId: nameEmission == undefined ? values.emissions : nameEmission.id,
                establishmentGeiInventoryId: params.idEstablishmentGei,
                baseUnit: values.base,
                eneIncome: values.ene,
                ene: values.ene,
                febIncome: values.feb == undefined ? null : values.feb,
                feb: values.feb == undefined ? null : values.feb,
                marIncome: values.mar == undefined ? null : values.mar,
                mar: values.mar == undefined ? null : values.mar,
                abrIncome: values.abr == undefined ? null : values.abr,
                abr: values.abr == undefined ? null : values.abr,
                mayIncome: values.may == undefined ? null : values.may,
                may: values.may == undefined ? null : values.may,
                junIncome: values.jun == undefined ? null : values.jun,
                jun: values.jun == undefined ? null : values.jun,
                julIncome: values.jul == undefined ? null : values.jul,
                jul: values.jul == undefined ? null : values.jul,
                agoIncome: values.ago == undefined ? null : values.ago,
                ago: values.ago == undefined ? null : values.ago,
                sepIncome: values.sep == undefined ? null : values.sep,
                sep: values.sep == undefined ? null : values.sep,
                octIncome: values.oct == undefined ? null : values.oct,
                oct: values.oct == undefined ? null : values.oct,
                novIncome: values.nov == undefined ? null : values.nov,
                nov: values.nov == undefined ? null : values.nov,
                dicIncome: values.dic == undefined ? null : values.dic,
                dic: values.dic == undefined ? null : values.dic,
                annual: null,
                unit: "",
                observations: values.observations == undefined ? "" : values.observations
            };
            await props.postResgistActivity(Activities);
        }
        handleCancel();
        const responseDataEstablishment = await props.getAllActivityByEstablishment(params.idEstablishmentGei);
        setDataTable(responseDataEstablishment);
        formValidate.resetFields();
    };

    const handleSelectChangeEmission = async (type: EmissionsSource) => {
        setSearchValue(type);
        const responseDataBaseUnit = await props.getTransformationFactorsUnitByEmissionSourceId(type);
        setDataBaseUnit(responseDataBaseUnit);
    };

    const handleViewRepository = async (value: any) => {
        await props.getPDFRepositories(value,isId);
    };

    const handleImportToExcel = () => {
        setIsImportExcel(true);
    }


    const handleExportToExcel = () => {
        const exportData = dataTable.map(item => ({
            'Fuente de Emisión': item.emission_source_name,
            'Unidad base': item.baseUnit,
            'Ene': item.ene,
            'Feb': item.feb,
            'Mar': item.mar,
            'Abr': item.abr,
            'May': item.may,
            'Jun': item.jun,
            'Jul': item.jul,
            'Ago': item.ago,
            'Sep': item.sep,
            'Oct': item.oct,
            'Nov': item.nov,
            'Dic': item.dic,
            'Anual': item.annual,
            'Unidad': item.unit,
            'Observaciones': item.observations,
            'Creado en': item.createdAt,
            'Actualizado en': item.updatedAt,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Actividad');

        const excelFileName = 'Actividad.xlsx';
        XLSX.writeFile(wb, excelFileName);

        openNotification("Exportación exitosa", `Los datos se han exportado a ${excelFileName}`);
    };

    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");
    const handleDeleteOk = async () => {
        const responseData = await props.deleteActivityDataById(isIdData);
        const responseDataEstablishment = await props.getAllActivityByEstablishment(params.idEstablishmentGei);
        setDataTable(responseDataEstablishment);
        setIsModalDeleteOpen(false);
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteOpen(true);

    }

    const showEmissionModalFalse = async () => {
        setIsModalEmision(false);
        setIsImportExcel(false);
    };
    const [isId, setIsId] = useState("");
    const showEmissionModalUpdate = async (value: string) => {
        setIsModalEmision(true);
        setIsId(value);
        const responseDataOrganization = await props.getRepositories(value);
        setDataTableEmissions(responseDataOrganization);
    };
    const onRegisterEmissions = async (values: any) => {
        const file = fileList[0];
        await props.postRepositories(values.month, isId, file)
        const responseDataOrganization = await props.getRepositories(isId);
        setDataTableEmissions(responseDataOrganization);
    }
    const onImportExcel = async (values: any) => {
        setIsImportExcel(false);
        const file = fileList[0];
        await props.postImportActivityDataExcel(file,params.idEstablishmentGei);
       
        formImportExcel.resetFields(); 
        const responseDataEstablishment = await props.getAllActivityByEstablishment(params.idEstablishmentGei);
        setDataTable(responseDataEstablishment);

       
    }
    const handleDeleteMethodOk = async () => {
        await props.deleteRepositories(isIdData, isId);
        setIsModalDeleteMethodOpen(false);

        const responseDataOrganization = await props.getRepositories(isId);
        setDataTableEmissions(responseDataOrganization);

    }
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButtonRepo = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }
    return (
        <>

            <Row justify="space-between" align="middle">

                <Col>
                    <Button
                        type="primary"
                        icon={<PlusCircleOutlined />}
                        className={style["create-button-user"]}
                        onClick={handleTypeOpenModel}
                    >
                        Agregar data de actividad
                    </Button>
                    <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                        onClick={handleExportToExcel}
                    >
                        Exportar a Excel
                    </Button>
                    <Button
                            type="primary"
                            icon={<FileExcelOutlined />}
                            style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                            onClick={handleImportToExcel}
                        >
                            Importar Datos
                        </Button>
                    

                </Col>
                <Col>
                    <Card title="Información GEI " style={{ width: 550, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <b>Año:  </b>{dataGeiAge}  <b> Responsable: </b> {dataGeiUser}
                    </Card>
                    <Card title="Información establecimiento " style={{ width: 550, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <b>Código:  </b>{dataEstaYear}  <b> Nombre: </b> {dataEstaName}
                    </Card>
                </Col>


            </Row>


            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />

            <Drawer title={typeModal ? "Crear data de actividad" : "Actualizar data de actividad"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <h3 className={style["title-modal"]}>
                </h3>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item label="Fuente de emisión" name="emissions" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={handleSelectChangeEmission}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga la fuente de emisión"
                        >
                            {selectDataTableEmissions.map((type: EmissionsSource) => (
                                <Option key={`type-option-${type.id}`} value={type.id}
                                >
                                    {type.name + "-" + type.flow}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Unidad base" name="base" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga la unidad base"
                        >
                            {dataBaseUnit.map((type: string) => (
                                <Option key={`type-option-${type}`} value={type}
                                >
                                    {type}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Enero" name="ene" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDecimal4(value) },
                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Febrero" name="feb" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Marzo" name="mar" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Abril" name="abr" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Mayo" name="may" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Junio" name="jun" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Julio" name="jul" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Agosto" name="ago" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Septiembre" name="sep" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Octubre" name="oct" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Noviembre" name="nov" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Diciembre" name="dic" rules={[
                        //para mantener el formato de los mensajes de informacion o error

                    ]}>
                        <Input placeholder="Ingresar dato" />
                    </Form.Item>
                    <Form.Item label="Observaciones" name="observations" rules={[
                        //para mantener el formato de los mensajes de informacion o error                           
                    ]}>
                        <Input placeholder="Ingresar la serie" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
            <Drawer open={isModalEmision} width={950} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={showEmissionModalFalse}>
                <h3>Agregar archivos por mes</h3>
                <Form
                    form={formRepository}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterEmissions}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item name="month" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select

                            showSearch
                            style={{ width: "20%" }}
                            onChange={(type: EmissionsSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga el mes"
                        >
                            {listMonths.map((type: any) => (
                                <Option key={`type-option-${type.id}`} value={type.id}
                                >
                                    {type.value}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item className={style["select-repo"]} name="repo" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Upload maxCount={1} {...propsRepo}>
                            <Button style={{ width: "110%" }} icon={<UploadOutlined />}>Subir archivo PDF</Button>
                        </Upload>

                    </Form.Item>

                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar archivo
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsEmissions} dataSource={dataTableEmissions} scroll={{ x: 500 }} />
            </Drawer>

            <Drawer open={isImportExcel} width={500} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={showEmissionModalFalse}>
              
                <Form
                    form={formImportExcel}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onImportExcel}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                
                    <Form.Item className={style["select-repo"]} name="repo" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Upload maxCount={1} {...propsRepoExcel} style={{ width: "280%" }}>
                            <Button style={{ width: "268%" }} icon={<UploadOutlined />}>Subir archivo Excel</Button>
                        </Upload>

                    </Form.Item>

                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                            style={{ width: "100%" }}
                        >
                            Importar archivo
                        </Button>
                    </Form.Item>
                </Form>
               
            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro que desea eliminar la data de actividad? </h3>
            </Modal>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar el archivo? </h3>
            </Modal>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getTransformationFactorsUnitByEmissionorganizationId, getAllActivityByEstablishment,
    getAllEmissionsTable, GetActivityById, postResgistActivity, putUpdateActivity,
    getEmissionsOrganization, getEstablishmentById,
    getGeiInventoryById, deleteActivityDataById,
    getRepositories, postRepositories, deleteRepositories, getPDFRepositories,
    GetEstablishmentGeiInventoryById, getTransformationFactorsUnitByEmissionId,
    getEmissionsById,postImportActivityDataExcel,getTransformationFactorsUnitByEmissionSourceId
})(TActivity);